<template>
  <div
    slot="pdf-content"
    class="pdf-content mb-4 w-full space-y-2 px-6 py-2 text-sm"
  >
    <div class="grid items-center grid-cols-3">
      <div class="flex-shrink-0 text-xs">
        <p>PT. NATURAL NUSANTARA</p>
        <p>Jl. Ring Road Barat No. 72 Salakan Trihanggo</p>
        <p>Gamping Sleman Jogjakarta 55291</p>
        <p>Telp:0274-6499191(Hunting) Fax:0274-6499192/6499193</p>
      </div>
      <p class="font-bold text-center">{{ originOffice.attributes.code }}</p>
      <div class="">
        <div class="grid grid-cols-5 gap-x-4">
          <p class="col-span-2">No. Cashbill</p>
          <p>:</p>
          <p class="col-span-2 font-bold">
            {{ order.attributes.origin_code }}/{{
              order.attributes.destination_code
            }}
          </p>
        </div>
        <div class="grid grid-cols-5 gap-x-4">
          <p class="col-span-2">Tanggal</p>
          <p>:</p>
          <p class="col-span-2">
            {{ order.attributes.createdAt | formatDate('DD/MM/YYYY') }}
          </p>
        </div>
      </div>
    </div>

    <p class="font-bold text-center uppercase">Kwitansi/Cashbill</p>

    <div class="grid grid-cols-2" style="margin-bottom: 20px;">
      <table>
        <tr>
          <td style="width: 80px;">Pembeli</td>
          <td style="width: 20px;">:</td>
          <td>{{ destinationOffice.attributes.name }}</td>
        </tr>
        <tr>
          <td style="width: 80px;">Sponsor</td>
          <td style="width: 20px;">:</td>
          <td>{{ destinationOffice.attributes.referred_by_name }}</td>
        </tr>
      </table>
      <table>
        <tr>
          <td style="width: 80px;">No. Kode</td>
          <td style="width: 20px;">:</td>
          <td>{{ destinationOffice.attributes.code }}</td>
        </tr>
        <tr>
          <td style="width: 80px;">No. Kode</td>
          <td style="width: 20px;">:</td>
          <td>{{ destinationOffice.attributes.referred_by }}</td>
        </tr>
      </table>
    </div>

    <table style="width: 100%; border: 1px solid black;">
      <tr>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black">Kdebrn</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">Jml</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">PV</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">Tot PV</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">BV</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">Tot BV</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">Harga</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-bottom: 1px solid black" class="text-right">Tot Harga</td>
      </tr>
      <tr v-for="detail in orderDetails" :key="detail.id">
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px">{{ detail.attributes.product_code }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.product_qty }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.point_value }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.product_qty * detail.attributes.point_value }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.bonus_value }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.product_qty * detail.attributes.bonus_value }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.product_price | toCurrency }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px" class="text-right">{{ detail.attributes.total_price | toCurrency }}</td>
      </tr>
      <tr>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-top: 1px solid black" colspan="3">{{ date | formatDate }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-top: 1px solid black" class="text-right">{{ order.attributes.grand_total_pv }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-top: 1px solid black" class="text-right"></td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-top: 1px solid black" class="text-right">{{ order.attributes.grand_total_bv }}</td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-top: 1px solid black" class="text-right"></td>
        <td style="padding: 10px; padding-top: 0; padding-bottom: 20px; border-top: 1px solid black" class="text-right">{{ order.attributes.grand_total_price | toCurrency }}</td>
      </tr>
    </table>

    <div class="flex justify-between">
      <div style="width: 200px;">
        <p>Catatan</p>
        <div style="height: 50px;">
        </div>
        <div>
          <p>Barang diterima dalam keadaan baik</p>
          <div style="height: 50px;"></div>
          <p>Tanda Tangan Pembeli <br> Lembar ke-1: Kantor Lembar ke-2: Pembeli Lembar ke-3: Stockist</p>
        </div>
      </div>
      <div style="width: 200px; margin-top: 10px;">
        <div>
          <div style="border: 1px solid black; height: 100px; text-align: center;">
            Ttd dan Cap Stockist
          </div>
          <small>Barang yang sudah dibeli tidak dapat dikembalikan</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: Object,
    originOffice: Object,
    destinationOffice: Object,
    orderDetails: Array,
    orderDetailBonuses: Array
  },
  computed: {
    date() {
      return new Date
    },
    dpp() {
      return (100 / 111) * this.order.attributes.grand_total_base_price;
    },
    ppn() {
      return (11 / 100) * this.dpp;
    },
    orderDetailsPerType() {
      return [
        {
          name: 'BARANG BERPOINT',
          summaryLabel: 'Total Berpoin',
          summarySpan: 3,
          summaries: [
            {
              id: 'total_bv',
            },
            {
              id: 'total_price',
              end: true,
              span: 3
            }
          ],
          columns: [
            {
              id: 'product_code',
              name: 'Kode',
              currency: false,
            },
            {
              id: 'product_name',
              name: 'Nama Barang',
              currency: false,
            },
            {
              id: 'qty',
              name: 'Jumlah',
              currency: true,
            },
            {
              id: 'bv',
              name: 'Total BV',
              currency: true,
            },
            {
              id: 'product_price',
              name: 'Harga Stc',
              currency: true,
            },
            {
              id: 'discount',
              name: 'Diskon',
              currency: true,
            },
            {
              id: 'total_price',
              name: 'Total Harga',
              currency: true,
            },
          ],
          data: this.orderDetails
            .filter((orderDetail) => orderDetail.attributes.is_point)
            .map((orderDetail) => ({
              product_code: orderDetail.attributes.product_code,
              product_name: orderDetail.attributes.product_name,
              qty: orderDetail.attributes.product_qty,
              bv: parseInt(orderDetail.attributes.bonus_value),
              total_bv: parseInt(orderDetail.attributes.bonus_value) * orderDetail.attributes.product_qty,
              product_price: orderDetail.attributes.product_price,
              discount: orderDetail.attributes.product_price < orderDetail.attributes.base_product_price ? orderDetail.attributes.base_product_price - orderDetail.attributes.product_price : null,
              total_price: orderDetail.attributes.total_price,
            })),
        },
        {
          name: 'BARANG NON POINT',
          summaryLabel: 'Total Non Poin',
          summarySpan: 6,
          summaries: [
            {
              id: 'total_price',
              end: true
            }
          ],
          columns: [
            {
              id: 'product_code',
              name: 'Kode',
              currency: false,
            },
            {
              id: 'product_name',
              name: 'Nama Barang',
              currency: false,
            },
            {
              id: 'qty',
              name: 'Jumlah',
              currency: true
            },
            {
              id: 'product_price',
              name: 'Harga Stc',
              currency: true,
              span: 2
            },
            {
              id: 'discount',
              name: 'Diskon',
              currency: true,
            },
            {
              id: 'total_price',
              name: 'Total Harga',
              currency: true,
            },
          ],
          data: this.orderDetails
            .filter((orderDetail) => !orderDetail.attributes.is_point)
            .map((orderDetail) => ({
              product_code: orderDetail.attributes.product_code,
              product_name: orderDetail.attributes.product_name,
              qty: orderDetail.attributes.product_qty,
              product_price: orderDetail.attributes.product_price,
              discount: orderDetail.attributes.product_price < orderDetail.attributes.base_product_price ? orderDetail.attributes.base_product_price - orderDetail.attributes.product_price : null,
              total_price: orderDetail.attributes.total_price,
            })),
        },
        {
          name: 'Free Produk',
          summaryLabel: 'Total Free Produk',
          summarySpan: 6,
          summaries: [
            {
              id: 'total_price',
              end: true
            }
          ],
          columns: [
            {
              id: 'product_code',
              name: 'Kode',
              currency: false,
            },
            {
              id: 'product_name',
              name: 'Nama Barang',
              currency: false,
            },
            {
              id: 'qty',
              name: 'Jumlah',
              currency: true
            },
            {
              id: 'product_price',
              name: 'Harga Stc',
              currency: true,
              span: 2
            },
            {
              id: 'discount',
              name: 'Diskon',
              currency: true,
            },
            {
              id: 'total_price',
              name: 'Total Harga',
              currency: true,
            },
          ],
          data: this.orderDetailBonuses.map(bonus => ({
            product_code: bonus.attributes.product_code,
            product_name: bonus.attributes.product_name,
            qty: bonus.attributes.bonus_qty,
            product_price: bonus.attributes.product_price,
            discount: bonus.attributes.product_price,
            total_price: 0
          }))
        },
      ];
    },
  },
  methods: {
    sum(data, key) {
      return data.reduce((res, item) => res + item[key], 0);
    },
  },
};
</script>

<style scoped>
.pdf-content {
  font-family: 'Courier New', Courier, monospace !important;
}
</style>
